import type { ReactElement } from "react";

import type { FiltersCategoryWithCountItem } from "../../types/category";

import { FilterCategoryChip } from "./FilterCategoryChip";
import { StyledChipsRow } from "./styles";

type Props = {
    categoryList: readonly FiltersCategoryWithCountItem[];
    selectedCategoryId: string;
    onClick: (categoryId: string) => void;
};

export const FilterCategoryChipList = ({ categoryList, selectedCategoryId, onClick }: Props): ReactElement => {
    return (
        <StyledChipsRow data-automation="filters-list.category-chips">
            {categoryList.map((item) => (
                <FilterCategoryChip
                    key={item.id}
                    isSelected={selectedCategoryId === item.id}
                    item={item}
                    onClick={onClick}
                />
            ))}
        </StyledChipsRow>
    );
};
